import * as React from 'react';
import {
  IconButton,
  Box,
  AppBar,
  useMediaQuery,
  Toolbar,
  styled,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { toggleMobileSidebar } from '../../../../store/customizer/CustomizerSlice';
import { NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import logoHeader from '../../../../assets/logoHeader.svg';
import menuImage from '../../../../assets/menuImage.svg';
import arrowLeftImage from '../../../../assets/arrowLeftImage.svg';
import menuDarkImage from '../../../../assets/menuDarkImage.svg';
import arrowDarkImage from '../../../../assets/arrowDarkImage.svg';
import { DARCKCOLOR } from '../../../../helpers/Config';

const Header = () => {
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const { guideId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // drawer
  const customizer = useSelector((state) => state.customizer);
  const dispatch = useDispatch();

  const AppBarStyled = styled(AppBar)(({ theme }) => ({
    background: theme.palette.background.paper,
    justifyContent: 'center',
    backdropFilter: 'blur(4px)',

    [theme.breakpoints.up('lg')]: {
      minHeight: customizer.TopbarHeight,
    },
  }));
  const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
    margin: '0 auto',
    width: '100%',
    color: `${theme.palette.text.secondary} !important`,
  }));

  return (
    <AppBarStyled
      position="sticky"
      color="default"
      elevation={8}
      sx={{
        boxShadow: 'none',
        background: `${guideId?.length ? 'transparent' : '#fff'}`,
        backdropFilter: `${guideId?.length ? 'none' : '4px'}`,
      }}
    >
      <ToolbarStyled
        sx={{
          // maxWidth: customizer.isLayout === 'boxed' ? 'lg' : '100%!important',
          // maxWidth: '400px',
          width: '100% !important',
          minHeight: '80px',
          height: '80px',
          '@media (min-width: 768px)': {
            maxWidth: '1000px',
          },
        }}
      >
        {/* <Box sx={{ width: lgDown ? '45px' : 'auto', overflow: 'hidden' }}>
          <Logo />
        </Box> */}
        {/* ------------------------------------------- */}
        {/* Toggle Button Sidebar */}
        {/* ------------------------------------------- */}
        {/* {lgDown ? ( */}

        {/* <Box sx={{ flex: '1 1', display: 'flex', alignItems: 'center', justifyContent: 'center' }} pl={ windowInnerWidth > 500 ? '70px' : '-25px'}> */}
        <Box
          sx={{ flex: '1 1', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
        >
          {/* <Logo /> */}
          {(!!guideId?.length || location.pathname === '/travel/guides') ? (
            <IconButton
              color="inherit"
              aria-label="arrow"
              onClick={() => navigate(-1)}
            >
              <Box
                component="img"
                src={location.pathname === '/travel/guides' ? arrowDarkImage : arrowLeftImage}
                alt="img"
                sx={{
                  width: '24px',
                  height: '24px',
                }}
              />
            </IconButton>
          ) : (
            <NavLink
              to="/travel"
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <Box
                component="img"
                src={logoHeader}
                alt="logo"
                sx={{
                  width: 'auto',
                  height: { xs: '40px', md: '43px', lg: '48px' },
                  objectFit: 'cover',
                  // ml: `${window.innerWidth >  ? '35px' : '-25px'}`,
                  // ml: { xs: '-20px', md: '35px' },
                }}
              />
            </NavLink>
          )}
        </Box>
        {
          location.pathname === '/travel/guides' && (
            <Box sx={{ flex: '5 1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography variant="h6" fontSize={'16px'} fontFamily={500} lineHeight={'24px'} color={DARCKCOLOR}>Guides</Typography>
            </Box>
          )
        }
        {true ? (
          <IconButton
            color="inherit"
            aria-label="menu"
            onClick={() => dispatch(toggleMobileSidebar())}
          >
            {/* <IconMenu2 /> */}
            <Box
              component="img"
              src={guideId?.length ? menuDarkImage : menuImage}
              alt="menu"
              sx={{
                width: 'auto',
                height: { xs: '40px' },
                maxWidth: '117px',
                objectFit: 'cover',
              }}
            />
          </IconButton>
        ) : (
          ''
        )}
        {/* ------------------------------------------- */}
        {/* Search Dropdown */}
        {/* ------------------------------------------- */}
        {/* <Search /> */}
        {/* {lgUp ? (
          <>
            <Navigation />
          </>
        ) : null} */}
        {/* <Box flexGrow={1} /> */}
        {/* <Stack spacing={1} direction="row" alignItems="center"> */}
        {/* <Language /> */}
        {/* ------------------------------------------- */}
        {/* Ecommerce Dropdown */}
        {/* ------------------------------------------- */}
        {/* <Cart /> */}
        {/* ------------------------------------------- */}
        {/* End Ecommerce Dropdown */}
        {/* ------------------------------------------- */}
        {/* <Notifications /> */}
        {/* {
            user.id ?
              <Profile />
              :
              <IconButton
                color="inherit"
                component={NavLink}
                to="/auth/login"
                disabled={isInIframe}
              >
                <LoginOutlinedIcon />
              </IconButton>
          } */}
        {/* </Stack> */}
      </ToolbarStyled>
    </AppBarStyled>
  );
};

Header.propTypes = {
  sx: PropTypes.object,
  toggleSidebar: PropTypes.func,
};

export default Header;
